import React, { useState } from "react";
import "./Intro.css";
import "./IntroMobile.css";
import { useNavigate } from "react-router-dom"; // Import navigation hook
import IntroAnimation from "./IntroAnimation";


const Intro = () => {
  const [country, setCountry] = useState("");
  const [region, setRegion] = useState("");
  const navigate = useNavigate(); // React Router navigation

  const usStates = [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
  ];
  
  const canadianProvinces = [
    "Alberta",
    "British Columbia",
    "Manitoba",
    "New Brunswick",
    "Newfoundland and Labrador",
    "Nova Scotia",
    "Ontario",
    "Prince Edward Island",
    "Quebec",
    "Saskatchewan",
  ];
  
  const handleNext = () => {
      navigate("/consultation", {
        state: { country, region },
      });
   };

  return (
    <div className="intro">

      
        <div className="location fade-in">
        {/* <div className="intro-text">
        <h1>
          Hi, I’m <span className="highlight">Divori</span>.
        </h1>
        <p>Here to help you get started with your divorce.</p>
      </div> */}

            <p2 className="title-location">Where are you located?</p2>
            <p2 className="title-location-2">Your location helps us personalize your guide.</p2>
            <br/>
          <select
            className="dropdown"
            value={country}
            onChange={(e) => setCountry(e.target.value)}
          >
            <option value="">Select Country ⬇️</option>
            <option value="US">United States</option>
            <option value="Canada">Canada</option>
          </select>

          {country && (
            <div className="region-input">
              <select
                className="dropdown"
                value={region}
                onChange={(e) => setRegion(e.target.value)}
              >
                <option value="">
                  {country === "US" ? "Select State ⬇️" : "Select Province ⬇️"}
                </option>
                {(country === "US" ? usStates : canadianProvinces).map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
          )}
        <button
            className="next-button"
            disabled={!country || !region.trim()}
            onClick={handleNext}
          >
            NEXT
          </button>
        </div>
    </div>
  );
};

export default Intro;